<template>
  <el-container id="index-wrapper" direction="vertical">
    <pcFromHead
      :logoSrc="logoSrc"
      :sysName="sysName"
      :menuData="menuData"
      :acColor="acColor"
      :bgColor="bgColor"
    ></pcFromHead>
    <el-main id="index-main">
      <section
        class="elMainSe"
        :style="{
          height: $route.meta.showFoot
            ? 'calc(100vh - 100px)'
            : 'calc(100vh - 80px)',
          width: this.offsetWidth > 1488 ? 'calc(100% - 100px)' : '100%'
        }"
      >
        <!-- <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" /> -->
        <router-view />
      </section>
    </el-main>
    <foot v-if="$route.meta.showFoot" :cpString="cpString"></foot>
  </el-container>
</template>
<script>
import pcFromHead from "@/components/pcFrom/head.vue";
import foot from "@/components/pcFrom/foot.vue";
import { menuData } from "@/views/rhqy/config/menuDataHT.js";
import { mapGetters } from "vuex";
export default {
  props: {},
  data() {
    return {
      cpString: menuData.cpString,
      menuData: menuData.menuData,
      logoSrc: menuData.logoSrc,
      sysName: menuData.sysName,
      acColor: menuData.acColor,
      bgColor: menuData.bgColor,
      offsetWidth: 1408
    };
  },
  watch: {
    $route(val) {
      if (val.path == "/rhqy/lyout") {
        this.intoPage();
      }
    }
  },
  components: {
    pcFromHead,
    foot
  },
  computed: {
    ...mapGetters(["privilegeConfig"])
  },
  async mounted() {
    this.offsetWidth = document.body.offsetWidth;
  },
  methods: {
    intoPage() {
      let menuData = JSON.parse(JSON.stringify(this.menuData));
      this.menuData = this.$common.filterByPrivilege(
        menuData,
        this.privilegeConfig
      );
      // 登录页面进入，进入第一个有权限的菜单
      if (this.$route.path == "/rhqy/lyout") {
        if (this.menuData[0].children) {
          this.$router.push(this.menuData[0].children[0].path);
        } else {
          this.$router.push(this.menuData[0].path);
        }
      }
      this.showComSelect = false;
      this.$nextTick(() => {
        this.showComSelect = true;
      });
    }
  },
  created() {
    this.intoPage();
  }
};
</script>
<style lang="less">
#index-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #ececec;
}

#index-main {
  padding: 0;
  height: calc(100% - 64px);
}

.elMainSe {
  box-sizing: border-box;
  margin: 8px auto 0px auto;
  background: #ffffff;
  border-radius: 4px;
}
</style>
